import { TableCell, TableRow } from '@mui/material';

import { ProcessedName, StyledIdTableCell } from '~/shared';

import { UseGetProductsReturnList } from '../../hooks';

export type ProductRowProps = {
  product: UseGetProductsReturnList[number];
};

export function ProductRow({ product }: ProductRowProps) {
  return (
    <TableRow
      key={product?.id}
      sx={{
        cursor: 'pointer',
        '&:hover': {
          '.MuiTableCell-body': {
            backgroundColor: theme => theme.palette.grey[100],
          },
        },
        '.MuiTableCell-body': {
          backgroundColor: 'background.paper',
        },
      }}
    >
      <StyledIdTableCell
        component="th"
        scope="row"
        align="center"
        sx={{ minWidth: '150px', width: '150px' }}
      >
        {product?.sku}
      </StyledIdTableCell>
      <TableCell
        component="th"
        scope="row"
        sx={{
          position: 'sticky',
          left: 0,
        }}
      >
        <ProcessedName name={product?.nome ?? 'Produto Indisponível'} />
      </TableCell>
      <TableCell component="th" scope="row" align="center">
        {product?.palavraChave}
      </TableCell>
      <TableCell component="th" scope="row" align="center">
        {product?.score}
      </TableCell>
    </TableRow>
  );
}
